<div class="issues-page">
  <div class="page-header">
    <div class="header-left">
      <h1 class="page-title"><mat-icon>confirmation_number</mat-icon> Issues</h1>
      <span class="count" *ngIf="!loading()">{{ totalCount() }} issue{{ totalCount() !== 1 ? 's' : '' }}</span>
    </div>
    <button mat-raised-button color="primary" (click)="showCreate = !showCreate">
      <mat-icon>add</mat-icon> New Issue
    </button>
  </div>

  <!-- Quick Create -->
  <mat-card class="create-card" *ngIf="showCreate">
    <mat-card-content>
      <div class="create-row">
        <mat-form-field appearance="outline" class="grow">
          <mat-label>Summary *</mat-label>
          <input matInput [(ngModel)]="newSummary" maxlength="500" (keyup.enter)="createIssue()" />
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>Project</mat-label>
          <mat-select [(ngModel)]="newProjectId">
            <mat-option *ngFor="let p of projects()" [value]="p.id">{{ p.name }}</mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>Type</mat-label>
          <mat-select [(ngModel)]="newType">
            <mat-option *ngFor="let t of typeOptions" [value]="t.value">{{ t.label }}</mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>Priority</mat-label>
          <mat-select [(ngModel)]="newPriority">
            <mat-option *ngFor="let p of priorityOptions" [value]="p.value">{{ p.label }}</mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>Deadline *</mat-label>
          <input matInput type="date" [(ngModel)]="newDueDate" required />
        </mat-form-field>
        <button mat-raised-button color="primary" [disabled]="creating() || !newDueDate" (click)="createIssue()">
          {{ creating() ? 'Creating…' : 'Create' }}
        </button>
      </div>
    </mat-card-content>
  </mat-card>

  <!-- Filters -->
  <div class="filter-bar tt-sticky-toolbar">
    <mat-form-field appearance="outline" class="search">
      <mat-label>Search</mat-label>
      <mat-icon matPrefix>search</mat-icon>
      <input matInput [value]="searchQuery" (input)="onSearch($any($event.target).value)" placeholder="Key or summary" />
    </mat-form-field>
    <mat-form-field appearance="outline">
      <mat-label>Saved filter</mat-label>
      <mat-select [(ngModel)]="savedFilterId" (ngModelChange)="onSavedFilterChange()">
        <mat-option value="">None</mat-option>
        <mat-option *ngFor="let f of savedFilters()" [value]="f.id">{{ f.name }}</mat-option>
      </mat-select>
    </mat-form-field>
    <a mat-stroked-button routerLink="/pm-advanced" [queryParams]="{ tab: 'search', projectId: projectFilter || null }">
      <mat-icon>tune</mat-icon> Advanced search
    </a>
    <mat-form-field appearance="outline">
      <mat-label>Project</mat-label>
      <mat-select [(ngModel)]="projectFilter" (ngModelChange)="onFilterChange()">
        <mat-option value="">All projects</mat-option>
        <mat-option *ngFor="let p of projects()" [value]="p.id">{{ p.name }}</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field appearance="outline">
      <mat-label>Type</mat-label>
      <mat-select [(ngModel)]="typeFilter" (ngModelChange)="onFilterChange()">
        <mat-option value="">All</mat-option>
        <mat-option *ngFor="let t of typeOptions" [value]="t.value">{{ t.label }}</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field appearance="outline">
      <mat-label>Status</mat-label>
      <mat-select [(ngModel)]="statusFilter" (ngModelChange)="onFilterChange()">
        <mat-option value="">All</mat-option>
        <mat-option *ngFor="let s of statusOptions" [value]="s.value">{{ s.label }}</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field appearance="outline">
      <mat-label>Priority</mat-label>
      <mat-select [(ngModel)]="priorityFilter" (ngModelChange)="onFilterChange()">
        <mat-option value="">All</mat-option>
        <mat-option *ngFor="let p of priorityOptions" [value]="p.value">{{ p.label }}</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field appearance="outline">
      <mat-label>Deadline</mat-label>
      <mat-select [(ngModel)]="deadlineFilter" (ngModelChange)="onFilterChange()">
        <mat-option *ngFor="let d of deadlineOptions" [value]="d.value">{{ d.label }}</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field appearance="outline">
      <mat-label>Sort by</mat-label>
      <mat-select [(ngModel)]="sortBy" (ngModelChange)="onFilterChange()">
        <mat-option *ngFor="let s of sortOptions" [value]="s.value">{{ s.label }}</mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <div class="jql-bar">
    <mat-form-field appearance="outline" class="grow">
      <mat-label>JQL (optional)</mat-label>
      <input matInput [(ngModel)]="jqlQuery" placeholder="status = Open AND assignee = me" (keyup.enter)="runJqlSearch()" />
    </mat-form-field>
    <button mat-stroked-button type="button" (click)="runJqlSearch()">Run JQL</button>
  </div>

  @if (selectedIds().size) {
    <div class="bulk-bar">
      <span>{{ selectedIds().size }} selected</span>
      <mat-form-field appearance="outline">
        <mat-label>Status</mat-label>
        <mat-select [(ngModel)]="bulkStatus">
          <mat-option *ngFor="let s of statusOptions" [value]="s.value">{{ s.label }}</mat-option>
        </mat-select>
      </mat-form-field>
      <button mat-stroked-button type="button" (click)="applyBulk('status')">Set status</button>
      <mat-form-field appearance="outline">
        <mat-label>Priority</mat-label>
        <mat-select [(ngModel)]="bulkPriority">
          <mat-option *ngFor="let p of priorityOptions" [value]="p.value">{{ p.label }}</mat-option>
        </mat-select>
      </mat-form-field>
      <button mat-stroked-button type="button" (click)="applyBulk('priority')">Set priority</button>
      <mat-form-field appearance="outline">
        <mat-label>Assignee</mat-label>
        <mat-select [(ngModel)]="bulkAssigneeId">
          <mat-option value="__unassign__">Unassigned</mat-option>
          <mat-option *ngFor="let e of employees()" [value]="e.id">{{ e.name }}</mat-option>
        </mat-select>
      </mat-form-field>
      <button mat-stroked-button type="button" (click)="applyBulk('assignee')">Assign</button>
      <button mat-stroked-button type="button" (click)="applyBulk('archive')">Archive</button>
      <button mat-stroked-button color="warn" type="button" (click)="applyBulk('delete')">Delete</button>
    </div>
  }

  <div class="error-banner" *ngIf="error()">
    <mat-icon>error_outline</mat-icon>
    <span>{{ error() }}</span>
    <button mat-icon-button (click)="error.set(null)"><mat-icon>close</mat-icon></button>
  </div>

  @if (loading()) {
    <app-skeleton variant="table-row" [count]="8"></app-skeleton>
  }

  <mat-card class="table-card" *ngIf="!loading()">
    <table mat-table [dataSource]="issues()" class="issues-table" *ngIf="issues().length; else empty">

      <ng-container matColumnDef="select">
        <th mat-header-cell *matHeaderCellDef>
          <mat-checkbox
            [checked]="allSelected()"
            [indeterminate]="someSelected()"
            (change)="toggleSelectAll()">
          </mat-checkbox>
        </th>
        <td mat-cell *matCellDef="let issue" (click)="$event.stopPropagation()">
          <mat-checkbox [checked]="isSelected(issue.id)" (change)="toggleSelect(issue.id)"></mat-checkbox>
        </td>
      </ng-container>

      <ng-container matColumnDef="key">
        <th mat-header-cell *matHeaderCellDef>Key</th>
        <td mat-cell *matCellDef="let issue" class="key-cell" (click)="openIssue(issue)">{{ issue.key }}</td>
      </ng-container>

      <ng-container matColumnDef="summary">
        <th mat-header-cell *matHeaderCellDef>Summary</th>
        <td mat-cell *matCellDef="let issue" (click)="openIssue(issue)">
          <div class="summary">{{ issue.summary }}</div>
          <div class="meta">{{ issue.projectName }}</div>
        </td>
      </ng-container>

      <ng-container matColumnDef="type">
        <th mat-header-cell *matHeaderCellDef>Type</th>
        <td mat-cell *matCellDef="let issue"><span class="chip type">{{ issue.typeLabel }}</span></td>
      </ng-container>

      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef>Status</th>
        <td mat-cell *matCellDef="let issue">
          <span class="tt-badge" [ngClass]="statusBadgeClass(issue.status)">{{ issue.statusLabel }}</span>
          @if (issue.isOverdue) {
            <span class="tt-badge tt-badge--overdue" matTooltip="Overdue">Overdue</span>
          }
        </td>
      </ng-container>

      <ng-container matColumnDef="priority">
        <th mat-header-cell *matHeaderCellDef>Priority</th>
        <td mat-cell *matCellDef="let issue">
          <span class="tt-badge" [ngClass]="priorityClass(issue.priority)">{{ issue.priorityLabel }}</span>
        </td>
      </ng-container>

      <ng-container matColumnDef="deadline">
        <th mat-header-cell *matHeaderCellDef>Deadline</th>
        <td mat-cell *matCellDef="let issue">
          <span [class.overdue-text]="issue.isOverdue">{{ issue.dueDate || '—' }}</span>
          @if (issue.deadlineBadge) {
            <span class="deadline-badge" [ngClass]="badgeClass(issue.deadlineBadge, issue.isOverdue, issue.completedOnTime)">{{ issue.deadlineBadge }}</span>
          }
        </td>
      </ng-container>

      <ng-container matColumnDef="remaining">
        <th mat-header-cell *matHeaderCellDef>Remaining</th>
        <td mat-cell *matCellDef="let issue">
          <span class="deadline-badge" [ngClass]="badgeClass(issue.deadlineBadge, issue.isOverdue, issue.completedOnTime)">
            {{ issueDeadlineLabel(issue) }}
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="delay">
        <th mat-header-cell *matHeaderCellDef>Delay</th>
        <td mat-cell *matCellDef="let issue">{{ issue.delayLabel || 'On time' }}</td>
      </ng-container>

      <ng-container matColumnDef="progress">
        <th mat-header-cell *matHeaderCellDef>Progress</th>
        <td mat-cell *matCellDef="let issue">{{ issue.progressPercent ?? 0 }}%</td>
      </ng-container>

      <ng-container matColumnDef="assignee">
        <th mat-header-cell *matHeaderCellDef>Assignee</th>
        <td mat-cell *matCellDef="let issue">{{ issue.assigneeName || 'Unassigned' }}</td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let issue">
          <button mat-icon-button matTooltip="Preview" (click)="previewIssue(issue, $event)">
            <mat-icon>visibility</mat-icon>
          </button>
          <button mat-icon-button [matMenuTriggerFor]="menu" (click)="$event.stopPropagation()">
            <mat-icon>more_vert</mat-icon>
          </button>
          <mat-menu #menu="matMenu">
            <button mat-menu-item (click)="openIssueFull(issue, $event)"><mat-icon>open_in_new</mat-icon> Open full page</button>
            <button mat-menu-item (click)="deleteIssue(issue, $event)"><mat-icon>delete</mat-icon> Delete</button>
          </mat-menu>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="columns"></tr>
      <tr mat-row *matRowDef="let row; columns: columns;" class="clickable-row" (click)="openIssue(row, $event)"></tr>
    </table>

    <ng-template #empty>
      <div class="tt-empty-state">
        <mat-icon>inbox</mat-icon>
        <h3>No issues found</h3>
        <p>Create one to get started or adjust your filters.</p>
        <div class="tt-empty-state__actions">
          <button mat-raised-button color="primary" (click)="showCreate = true">
            <mat-icon>add</mat-icon> New Issue
          </button>
        </div>
      </div>
    </ng-template>

    <mat-paginator
      *ngIf="totalCount() > pageSize"
      [length]="totalCount()"
      [pageSize]="pageSize"
      [pageIndex]="page"
      [pageSizeOptions]="[10, 20, 50]"
      (page)="onPageChange($event)"
      showFirstLastButtons>
    </mat-paginator>
  </mat-card>
</div>
